import * as React from 'react';
import { useState } from 'react';
import { Col, Row, Form, Nav, Card, Button, ListGroup, Badge, Alert, Modal, Spinner } from "react-bootstrap";

class LegendCircles extends React.Component {

	
	constructor(props) {
		super(props);
	}
	
	removeHandler(e){
		
		var circleid = e.target.parentNode.dataset.circleid;
		
		this.props.onRemove(this.props.scenario, circleid);
		
		this.forceUpdate();
	}
	handleMouseEnter(e){
		e.stopPropagation();
		var circleid = e.currentTarget.dataset.circleid;
		this.props.onEnter(circleid, 3);
	}
	handleMouseLeave(e){
		e.stopPropagation();
		var circleid = e.currentTarget.dataset.circleid;
		this.props.onLeave(circleid, 1.5);
	}
	
	render(){
		if(this.props.scenario && this.props.scenario.circles && this.props.scenario.circles.length) {
			return (
				<div className="legend circles border rounded bg-light">
					<ul>

						{

							this.props.scenario.circles.map((circle, j)=>{
								return (
									<li data-circleid={circle.circleid} key={j} onMouseEnter={(e)=>{this.handleMouseEnter(e)}} onMouseLeave={(e)=>{this.handleMouseLeave(e)}}>
										<span className="bullet" style={{borderColor:circle.color}}></span>
										<span className="text" title={circle.name+' ('+circle.radius+'m)'}>{circle.name} <small>({circle.radius}m)</small></span>

										{/*<i className="ri-pencil-line"></i>*/}
										<i onClick={(e)=>{this.removeHandler(e)}} title="Remove Circle" className="ri-delete-bin-line"></i>
									</li>
								)
							})

						}

					</ul>

				</div>
			)
		}
		return;
	}
} 
export default LegendCircles;